module.exports = __webpack_public_path__ + "static/media/badge_pinde.b1ebafb1.png";